<template>
    <div class="card-set-wrap flex" v-loading="loading">
        <div class="card-set-left">
            <div class="tip-title flex">
                <div>
                    <p class="text-bold">名片预览</p>
                    <p>按住可拖动排序字段位置</p>
                </div>
                <el-button type="primary" @click="handleClickSave">保存</el-button>
            </div>
            <div class="user-info-card thin-scrollbar">
                <div class="user-info-card-header">
                    <img :src="defaultImg" alt="" />
                    <div>
                        <p class="ellipsis">张三</p>
                        <p class="ellipsis">总经办</p>
                    </div>
                </div>
                <ul class="user-info-card-content">
                    <draggable
                        v-model="userInfoCard.content"
                        :group="activeDraggable"
                        :move="onDraggableMove"
                        ghost-class="card-ghost-item"
                        chosen-class="card-chosen-item"
                    >
                        <li v-for="(item, index) in userInfoCard.content" :key="index">
                            <p>{{ item.field_name }}</p>
                            <p>{{ item.field_value || "******" }}</p>
                        </li>
                    </draggable>
                </ul>
            </div>
        </div>
        <div class="card-set-right">
            <div class="tip-title flex">
                <div>
                    <p class="text-bold">字段选择</p>
                    <p>个人敏感信息不建议添加到名片中展示，最多可选4个字段</p>
                </div>
            </div>
            <ul>
                <li :key="item.field_id" v-for="item in group_list" class="group_item">
                    <div class="label_title" v-if="item.field_id">
                        <span v-text="item.field_name"></span>
                    </div>
                    <div class="check_box">
                        <div :key="field.id" v-for="field in item._child.filter(child=>child.field_type !=='id_card')">
                            <el-checkbox
                                v-model="field.checked"
                                :disabled="
                                    field.field_key == 'name' ||
                                    field.field_key == 'department_id' ||
                                    (userInfoCard.content.length == 4 &&
                                        !isCludes(userInfoCard.content, field.field_key))
                                "
                                @change="handleCheckboxChange(field)"
                                >{{ field.field_name }}</el-checkbox
                            >
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { getFormFields, GetUserCard, SetUserCard } from "@/api";
import draggable from "vuedraggable";
export default {
    name: "BusinessCardSet",
    components: { draggable },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            activeDraggable: "userTagItem",
            userInfoCard: {
                content: [],
                infoData: {},
                header: [],
            },
            group_list: [],
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        this.getUserCard();
    },
    methods: {
        isCludes(fieldList, field_key) {
            return fieldList.map((userField) => userField.field_key).includes(field_key);
        },
        getUserCard() {
            this.loading = true;
            GetUserCard({ user_id: this.userInfo.user.id }).then((res) => {
                if (res.code === 200) {
                    this.userInfoCard.infoData = res.data.data || {};
                    this.userInfoCard.header = res.data.header || [];
                    this.getFieldList();
                } else {
                    this.loading = false;
                }
            });
        },
        getFieldList() {
            getFormFields({
                field_form: "users",
            }).then((res) => {
                if (res.code == 200) {
                    let data = res.data || [];
                    let all_keys = data.map(item=> {
                        return item._child.map(child=> child.field_key)
                    })
                    all_keys = all_keys.flat()
                    let new_header = []
                    // 清空已经删除的自定义控件数据
                    this.userInfoCard.header.forEach(item=> {
                        if(item.field_key =='avatar' || all_keys.includes(item.field_key)) {
                            new_header.push(item)
                        }
                    })
                    this.userInfoCard.header = new_header
                    let fieldContent = {};
                    let fieldkey = this.userInfoCard.header.map((item) => item.field_key);
                    this.userInfoCard.header.forEach((item) => {
                        fieldContent[item.field_key] = {
                            ...item,
                            field_value: "",
                        };
                    });
                    data.forEach((group) => {
                        group._child = group._child
                            .filter(
                                (item) =>
                                    item.field_type !== "table" &&
                                    item.field_type !== "relate_approve_form" &&
                                    item.field_type !== "textarea" &&
                                    item.field_type !== "image" &&
                                    item.field_type !== "file"
                            )
                            .map((item) => {
                                item.checked =
                                    item.field_key == "name" ||
                                    item.field_key == "department_id" ||
                                    fieldkey.includes(item.field_key)
                                        ? true
                                        : false;
                                if (fieldkey.includes(item.field_key)) {
                                    fieldContent[item.field_key] = {
                                        field_key: item.field_key,
                                        field_name: item.field_name,
                                        field_type: item.field_type,
                                        field_value: this.getFieldValue(item.field_type, item.field_key),
                                    };
                                }
                                return item;
                            });
                        this.userInfoCard.content = Object.values(fieldContent).filter(
                            (item) =>
                                item.field_key !== "name" &&
                                item.field_key !== "department_id" &&
                                item.field_key !== "department" &&
                                item.field_key !== "avatar"
                        );
                    });
                    this.group_list = data;
                }
                this.loading = false;
            });
        },
        getFieldValue(field_type, field_key) {
            // let data = "";
            // if (field_type === "radio" && field_key == "gender") {
            //     data =
            //         this.userInfoCard.infoData[field_key] == 1
            //             ? "男"
            //             : this.userInfoCard.infoData[field_key] == 2
            //             ? "女"
            //             : "未知";
            // } else if (this.userInfoCard.infoData[field_key] && Array.isArray(this.userInfoCard.infoData[field_key])) {
            //     data = this.userInfoCard.infoData[field_key].join("、");
            // } else if (field_type == "address") {
            //     data = this.userInfoCard.infoData[field_key] && this.userInfoCard.infoData[field_key].detail_adress;
            // } else {
            //     data = this.userInfoCard.infoData[field_key];
            // }
            // return data;
            let data = "******";
            if (field_key == "position") {
                data = "销售专员";
            } else if (field_key == "superior_id") {
                data = "李四";
            } else if (field_key == "phone") {
                data = "13800000000";
            } else if (field_key == "user_tag_id") {
                data = "销售";
            }
            return data;
        },
        // 按照数据顺序排序

        onDraggableMove(e) {
            // console.log(e, 'e====')
        },
        // 选择框改变
        handleCheckboxChange(item) {
            let check_list = JSON.parse(JSON.stringify(this.userInfoCard.content));
            if (item.checked) {
                check_list.push({
                    field_key: item.field_key,
                    field_name: item.field_name,
                    field_type: item.field_type,
                });
            } else {
                const index = check_list.findIndex((checkItem) => checkItem.field_key == item.field_key);
                check_list.splice(index, 1);
            }
            this.userInfoCard.content = check_list;
        },
        // 保存
        handleClickSave() {
            let field_keys = [
                { field_key: "name", field_name: "姓名", field_type: "input" },
                { field_key: "department_id", field_name: "部门", field_type: "department" },
                ...this.userInfoCard.content,
            ];
            if(!field_keys.find(item=> item.field_key === 'avatar')) {
                field_keys.push({field_key: 'avatar', field_name: "头像", field_type: "file"})
            }
            SetUserCard({ field_keys }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.getUserCard();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/user-card.scss";

.card-set-wrap {
    height: 100%;

    .el-button {
        padding: 8px 15px;
    }

    .tip-title {
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 24px;

        p {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 17.38px;
            color: rgba(153, 153, 153, 1);
        }

        .text-bold {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }

    .card-set-left {
        width: 402px;
        height: 100%;
        border-radius: 0px 0px, 8px, 0px;
        background: rgba(0, 0, 0, 0.04);
        padding: 16px 60px;
    }

    .card-set-right {
        padding: 16px 60px;

        .group_item {
            margin-bottom: 12px;

            .label_title {
                position: relative;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                height: 22px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                padding-left: 12px;
                margin-bottom: 16px;

                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 4px;
                    height: 22px;
                    opacity: 1;
                    border-radius: 20px;
                    background: rgba(41, 144, 255, 1);
                }
            }

            .check_box {
                display: flex;
                flex-wrap: wrap;

                div {
                    width: 216px;
                    margin-bottom: 12px;
                }

                div:nth-of-type(2n) {
                    width: calc(100% - 216px);
                }
            }
        }
    }
}

.user-info-card {
    position: relative;
    .user-info-card-content {
        li {
            cursor: pointer;

            &:hover {
                border-radius: 4px;
                background: rgba(0, 0, 0, 0.04);
            }
        }

        .card-ghost-item,
        .card-chosen-item {
            border: 1px solid rgba(232, 232, 232, 1);
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.08);
        }
    }
}
</style>
<style lang="scss">
.el-checkbox {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(102, 102, 102, 1);

    .el-checkbox__input {
        font-size: 16px;
    }

    ::v-deep {
        .el-checkbox__inner {
            width: 16px;
            height: 16px;
            border-color: rgba(217, 217, 217, 1);
        }
    }
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: rgba(41, 144, 255, 1);
    background-color: rgba(41, 144, 255, 1);
}

.el-checkbox__input.is-disabled .el-checkbox__inner {
    border-color: rgba(217, 217, 217, 1);
    background-color: rgba(243, 243, 243, 1);
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: rgba(182, 217, 255, 1);
    border-color: rgba(182, 217, 255, 1);
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #ffffff;
}
</style>
